/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tier_3_DInputs */

const en_cp_tier_3_d = /** @type {(inputs: Cp_Tier_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 1 Campus Partner MoU or ≥ 40 active teams from your campus. Name on this page, founder session, partner-internship priority.`)
};

const id_cp_tier_3_d = /** @type {(inputs: Cp_Tier_3_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`≥ 1 MoU Kampus Mitra atau ≥ 40 tim aktif dari kampusmu. Nama di halaman ini, sesi dengan founder, prioritas magang mitra.`)
};

/**
* | output |
* | --- |
* | "≥ 1 Campus Partner MoU or ≥ 40 active teams from your campus. Name on this page, founder session, partner-internship priority." |
*
* @param {Cp_Tier_3_DInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tier_3_d = /** @type {((inputs?: Cp_Tier_3_DInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tier_3_DInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tier_3_d(inputs)
	return en_cp_tier_3_d(inputs)
});